/* eslint-disable no-throw-literal */
import { FACILITY_ENDPOINT, EXTERNAL_SOURCE_FACILITY_ENDPOINT, INTERNAL_SOURCE_FACILITY_ENDPOINT, GROUP_ENDPOINT } from '../config/api-endpoints'
import { authorizeHeader } from '../utils/auth-header'
import { v4 as uuidV4 } from 'uuid';
import { getLocalStatusURL } from '../utils/helpers';


export const postCreateFacilityAPICall = async ({ sourceFacilityName, sourceGroupGuid, facilityType }) => {
  try {
    const guid = uuidV4()
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ guid: guid, name: sourceFacilityName, member_of: sourceGroupGuid, facilityType })
    }
    const response = await window.fetch(FACILITY_ENDPOINT, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}
export const getExternalSourceFacilitiesCall = async () => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let endpointToHit = EXTERNAL_SOURCE_FACILITY_ENDPOINT
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}

export const getInternalSourceFacilitiesCall = async () => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let endpointToHit = INTERNAL_SOURCE_FACILITY_ENDPOINT
    const response = await window.fetch(endpointToHit, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}



export const getFacilityStatusApiCall = async (studyGuid) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let targetUrl = getLocalStatusURL()
    const response = await window.fetch(targetUrl, authorizeHeader(config))
    const responseStatus = await response.status

    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const postCreateGroupAPICall = async (payload) => {
  try {
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    }
    const response = await window.fetch(GROUP_ENDPOINT, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const getCheckGroupAPICall = async () => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const response = await window.fetch(GROUP_ENDPOINT, authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}


export const getSingleGroupAPICall = async (groupId) => {
  try {
    const config = {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    const response = await window.fetch(GROUP_ENDPOINT + '/' + encodeURIComponent(groupId), authorizeHeader(config))
    const responseStatus = await response.status
    let responseJSON;
    const contentType = response.headers.get("content-type");
    if (contentType && contentType.indexOf("application/json") !== -1) {
      responseJSON = await response.json()
    } else{
      throw {
        responseStatus,
        message: `${responseStatus} Response is not a JSON.`
      };
    }
    return { responseStatus, responseJSON }
  } catch (e) {
    console.error(e.message)
    return e
  }
}
  